module.exports = __webpack_public_path__ + "img/golfsurfen--white.68d50936.svg";